import { Channel, Program } from '@interaction-gaming/planby'

export type Bookable = Channel & {
  gridDisplayMode: GridDisplayMode
  formattedDay: string | null
  isToday: boolean
}

export type ReservationGridDisplayItem = Program & {
  subDescription?: string
  isReservation: boolean
  gridDisplayMode: GridDisplayMode
  formattedStartTime: string
  claimFormId?: string | null
  claimFormAuthorized?: boolean
  checkedInAt?: Date | null
  noShowAt?: Date | null
}

export const enum GridDisplayMode {
  DAY = 'DAY',
  WEEK = 'WEEK',
}

export const DEFAULT_MAX_TICKETS_PER_RESERVATION = 15
